import { Radio } from '../interface/interface';

export const mapPermissionsToOptions = (permissions: Radio[]) =>
  permissions.map((permission) => ({
    value: permission.value,
    option: permission.label,
  }));
